import { CubePresenter, Logger, NOOP_VOID } from 'wdc-cube';
import { HUB_ROLES, hasAnyRole } from '../../../../domain';
import { ApiClient, currentHistoryCodec, unsealAddress } from '../../../../infra';
import { AccountApi } from '../account.api';
import { Places } from '../../../route-consts';
import { ForgotPasswordKeys } from '../forgot/forgot-password.key';
import { SignInKeys } from './auth.key';
import { SignInScope } from './auth.scope';
const LOG = Logger.get('Mormaii.SignInPresenter');
// @Inject
const api = AccountApi.INSTANCE;
// @Inject
const client = ApiClient.INSTANCE;
export class SignInPresenter extends CubePresenter {
    constructor(app) {
        super(app, new SignInScope());
        this.parentSlot = NOOP_VOID;
    }
    async applyParameters(intent, initialization) {
        const keys = new SignInKeys(this.app, intent);
        // Lido em toda chegada, nao so na primeira: quem e barrado duas vezes ia
        // para lugares diferentes nas duas.
        this.next = keys.next;
        if (initialization) {
            this.scope.onEmailChanged = this.handleEmailChanged.bind(this);
            this.scope.onPasswordChanged = this.handlePasswordChanged.bind(this);
            this.scope.onSignIn = this.action(this.onSignIn);
            this.scope.onForgotPassword = this.action(this.onForgotPassword);
            LOG.info('Initialized');
        }
        // O slot e decidido acima na composicao e pode mudar entre viagens: le-se sempre.
        this.parentSlot = keys.parentSlot;
        this.parentSlot(this.scope);
        return true;
    }
    /**
     * O destino volta para a URL porque o endereco e derivado, nao guardado: um
     * parametro que o presenter nao publica desaparece do endereco no proximo
     * write, e um reload na porta esqueceria para onde o leitor ia.
     */
    publishParameters(intent) {
        const keys = new SignInKeys(this.app, intent);
        keys.next = this.next;
    }
    // Nao sao acoes: so espelham o que foi digitado, e redesenhar o campo a cada
    // tecla e como um campo perde o cursor.
    handleEmailChanged(value) {
        this.scope.email = value;
    }
    handlePasswordChanged(value) {
        this.scope.password = value;
    }
    async onForgotPassword() {
        await ForgotPasswordKeys.of(this.app).flip();
    }
    async onSignIn() {
        const email = (this.scope.email ?? '').trim();
        const password = this.scope.password ?? '';
        if (!email || !password) {
            this.scope.error = 'Informe e-mail e senha.';
            return;
        }
        this.scope.busy = true;
        this.scope.error = undefined;
        try {
            const session = await api.signIn(email, password);
            /**
             * Quem nao tem papel de painel nao entra - o cliente dele e o app.
             *
             * A checagem era por PRESENCA de `ROLE_PATIENT`, herdada do painel antigo, e
             * com ela uma conta que acumulasse paciente e profissional ficava de fora.
             * Isso deixou de valer em 18/09/2026, quando o cliente decidiu que pessoa e um
             * conceito independente do papel: ela tem UMA conta e ganha papeis, e "ser
             * paciente" deixou de poder significar "nao e mais nada".
             *
             * Na base de QA a regra antiga trancava OITO pessoas para fora, duas delas
             * super administradores - eles nao entravam no proprio painel porque tambem
             * usam a pulseira. O sintoma apareceu na conta de Leticia, que acumulou
             * administradora de empresa ao ser fundida.
             *
             * A intencao original continua de pe, e e o que esta escrito agora: quem so e
             * paciente nao tem o que fazer aqui.
             */
            if (!hasAnyRole(session.roles, HUB_ROLES)) {
                client.clearSession();
                this.scope.error = 'Não é possível conectar com usuários de paciente.';
                return;
            }
            await this.app.establishSession(session);
            /*
             * A chave e desta pessoa, entao ela so existe agora. Selar ANTES de
             * viajar e o que faz o primeiro endereco de dentro ja sair cifrado.
             */
            const codec = await currentHistoryCodec();
            this.app.sealAddress(codec);
            if (this.next) {
                // O `next` pode ter atravessado a porta selado - ver `unsealAddress`.
                await this.app.flipToIntentString(codec ? unsealAddress(this.next, codec) : this.next);
                return;
            }
            await this.app.flip(Places.hub);
        }
        catch (caught) {
            this.scope.error = caught instanceof Error ? caught.message : 'Não foi possível entrar.';
        }
        finally {
            this.scope.busy = false;
            this.scope.password = '';
        }
    }
}
//# sourceMappingURL=auth.presenter.js.map